import { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { toast } from 'react-toastify';
import moment from 'moment';
import useMultiLanguage from '../../../hook/useMultiLanguage';
import AppContext from '../../../AppContext';
import { IAttribution, IKHChamCong, ITableTimesheet, ITimesheet } from '../models/timesheetModels';
import { EXPORT_FILE_NAME, RESPONSE_STATUS_CODE, SEARCH_OBJECT_MAX_SIZE, TYPE, TYPE_REF, VARIABLE_STRING } from '../../constants/moduleConsts';
import { getListWorkDay, searchSymbol, updateListWorkDay } from '../../category/services/symbolServices';
import { approveTimeSheet, autoUpdateTimeSheet, searchTimeSheet, updateTimeSheet } from '../services/timesheetServices';
import { exportToFile, hasAuthority } from '../../utils/functionUtils';
import { PERMISSION_ABILITY, PERMISSIONS } from '../../../constants';
import { CODE_WEEKEND } from '../constants/timesheetConsts';
import { exportTimeSheet } from '../../services/exportFileServices';
import { GroupButton } from '../../components/GroupButton';
import { KTSVG } from '../../../../_metronic/helpers';
import TableTimesheets from './TableTimesheet';
import TextValidator from '../../components/input/text-validator';
import { CODE_STATUS } from '../../manager-request/constants/managerRequestConsts';
import { ConfirmDialog } from '../../components/dialogs';
import DialogListAttribution from '../../timekeeping-overview/components/DialogListAttribution';
import DialogTypeExportTimekeeping from '../../timekeeping-overview/components/DialogTypeExportTimekeeping';
import { searchAllSimpleValue } from '../../services/services';
import DialogPrintTimekeeping from './DialogPrintTimekeeping';

export interface IPropsTimesheetForm {
  timesheetInfo: ITimesheet;
  handleClose: () => void;
  handleCloseAndSearch: () => void;
}

const TimesheetForm = (props: IPropsTimesheetForm) => {
  const { timesheetInfo, handleClose, handleCloseAndSearch } = props;
  const { lang } = useMultiLanguage();
  const { setPageLoading } = useContext(AppContext);
  const refsArray = useRef<any[]>([]);

  const [initDataTable, setInitDataTable] = useState<ITableTimesheet[]>([]);
  const [isView, setIsView] = useState<boolean>(true);
  const [dataKHChamCong, setDataKHChamCong] = useState<IKHChamCong[]>([]);
  const [shouldOpenApproveDialog, setShouldOpenApproveDialog] = useState<boolean>(false);
  const [isShowSymbol, setIsShowSymbol] = useState<boolean>(false);
  const [listAttribution, setListAttribution] = useState<IAttribution[]>([]);
  const [openDialogListAttribution, setOpenDialogListAttribution] = useState(false);
  const [openDialogTypeExport, setOpenDialogTypeExport] = useState({
    open: false,
    data: []
  });
  const [openDialogPrint, setOpenDialogPrint] = useState<any>({
    open: false,
    dataSearchPrint: null
  });

  const getDataKHChamCong = async () => {
    try {
      const { data } = await searchSymbol(SEARCH_OBJECT_MAX_SIZE);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        const listData = data.data.content || [];
        listData.forEach((item: IKHChamCong) => item.isEdited = true);
        setDataKHChamCong(listData);
        return;
      }
      toast.warning(data?.message);
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    }
  }

  const getListAttribution = useCallback(async (searchData: any = {}) => {
      try {
        const { data } = await getListWorkDay(searchData);
        if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
          setListAttribution(data.data.content);
        } else toast.warning(data?.message);
      } catch (error) {
        toast.error(lang("GENERAL.ERROR"));
      }
    }, [lang]);

  useEffect(() => {
    getDataKHChamCong();
    handleSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getListAttribution();
  }, [getListAttribution]);

  const handleSearch = async () => {
    try {
      setPageLoading(true);
      let { phongBanId, nam, thang } = timesheetInfo;
      let searchObject = {
        ...SEARCH_OBJECT_MAX_SIZE,
        nam,
        thang,
        phongBanId
      };
      setOpenDialogPrint({
        open: false,
        dataSearchPrint: searchObject
      })
      const { data } = await searchTimeSheet(searchObject);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setInitDataTable(data?.data?.content || [])
        setIsView(true);
        return;
      }
      toast.warning(data?.message);
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  const handleSubmit = useCallback(async () => {
    try {
      let dataTable: ITableTimesheet[] = handleConvertTableRef(refsArray.current, [...initDataTable]);

      let { data } = await updateTimeSheet(handleCheckEdited(dataTable))
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        toast.success(lang("TOAST.EDIT.SUCCESS"));
        handleSearch();
        return;
      }
      toast.warn(data?.message);
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  }, [initDataTable]);

  const setRefsArray = useCallback((index: any, key: any, typeRef: string = TYPE_REF.INPUT_REF, id: string) => (element: any) => {
    let newElement = element ? element : {}
    newElement.typeRef = typeRef;
    newElement.id = id;
    refsArray.current[index] = refsArray.current[index] || {};
    refsArray.current[index][key] = newElement;
  }, []);

  const handleConvertTableRef = (data: any[], dataTable: ITableTimesheet[] = []): any => {
    let dataArray: any[] = dataTable.map(item => ({ ...item }));

    for (let itemRef of data || []) {
      let indexItem = dataArray.findIndex((itemBN: ITableTimesheet) => itemBN?.id === itemRef?.[VARIABLE_STRING.EMPLOYEE]?.id);

      if (indexItem < 0) return;

      for (let [key, value] of Object.entries(itemRef)) {
        if (key === VARIABLE_STRING.EMPLOYEE) continue;

        let listValue = (value as any).getValue();
        let itemValue = checkIsEditedItem(dataArray[indexItem][key], listValue?.[0])

        dataArray[indexItem][key] = itemValue
      }
    }

    return dataArray;
  }

  const checkIsEditedItem = (itemBefore: IKHChamCong | null | undefined, itemAfter: IKHChamCong | null | undefined) => {
    if (itemBefore && !itemAfter) {
      return {
        id: itemBefore?.defaultCode === CODE_WEEKEND ? itemBefore?.id : null,
        isEdited: itemBefore?.defaultCode !== CODE_WEEKEND
      }
    };

    if ((!itemBefore && !itemAfter) || (itemBefore && itemAfter && itemBefore?.id === itemAfter?.id)) {
      return {
        id: itemBefore?.id,
        isEdited: false
      }
    };

    return {
      id: itemAfter?.id,
      isEdited: true
    }
  }

  const handleCheckEdited = (dataTable: ITableTimesheet[]) => {
    return dataTable.filter((item: ITableTimesheet) => {
      let isCheck = Object.entries(item).some(([key, value]) => value?.isEdited);
      if (!isCheck) return isCheck;

      for (let [key, value] of Object.entries(item)) {
        if (typeof value === TYPE.OBJECT && !value?.id && !value?.isEdited) (item as any)[key] = null
      }
      return isCheck;
    }) || []
  }

  const handleIsView = useCallback((isViews: boolean) => {
    setPageLoading(true);
    setTimeout(() => {
      setIsView(isViews)
      setPageLoading(false);
    }, 10)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleExportExcel = (listCode: string[]) => {
    if (!initDataTable.length) {
      toast.warning(lang("GENERAL.NO_DATA_TO_EXPORT"));
      return;
    }

    let { donViCongTacCode, donViCongTacText, phongBanId, phongBanText, nam, thang } = timesheetInfo;
    let searchObject = {
      ...SEARCH_OBJECT_MAX_SIZE,
      nam,
      thang,
      phongBanId,
      phongBanText,
      orgCode: donViCongTacCode,
      orgText: donViCongTacText,
      exportType: listCode
    };
    exportToFile({
      exportAPI: () => exportTimeSheet(searchObject),
      fileName: `${EXPORT_FILE_NAME.BANG_CHAM_CONG}${thang ? " tháng " + thang
        : ""}${nam ? " năm " + nam : ""}`,
      setPageLoading
    });
    setOpenDialogTypeExport({
      open: false,
      data: []
    });
  }

  const updateAutoTimeSheets = async () => {
    try {
      setPageLoading(true);
      let { phongBanId, phongBanText, nam, thang } = timesheetInfo;
      let searchObject = {
        nam,
        thang,
        phongBanId,
        phongBanText
      };

      const { data } = await autoUpdateTimeSheet(searchObject);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        toast.success(lang("TOAST.EDIT.SUCCESS"));
        handleSearch();
      } else toast.warning(data?.message);
    } catch (error) {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  };

  const handleCloseForm = () => {
    setShouldOpenApproveDialog(false);
  }

  const handleConfirm = async () => {
    try {
      setPageLoading(true);
      const { data } = await approveTimeSheet(timesheetInfo.id);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        toast.success("Duyệt bảng công thành công");
        handleCloseAndSearch();
        handleCloseForm();
      } else toast.warn(data?.message);
    } catch {
      toast.error(lang("GENERAL.ERROR"));
    } finally {
      setPageLoading(false);
    }
  }

  const handleSaveAttribution = async (listAttribution: IAttribution[]) => {
    try {
      setPageLoading(true);
      const { data } = await updateListWorkDay(listAttribution);
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        getListAttribution();
        setOpenDialogListAttribution(false);
      }
    } catch (error) {
      console.error("ERROR", error);
    } finally {
      setPageLoading(false);
    }
  };

  const handleExportTimekeeping = async () => {
    try {
      const { data } = await searchAllSimpleValue({
        pageIndex: 1,
        pageSize: 9999,
        type: 67,
        attributeCode: "CC",
      });
      if (data?.code === RESPONSE_STATUS_CODE.SUCCESS) {
        setOpenDialogTypeExport({
          open: true,
          data: data.data.content
        })
      }
    } catch (error) {
      console.error("ERROR", error);
    }
  };

  return (
    <div>
      <div className="header-form-action">
        <GroupButton type="btn-back" handleClose={handleClose} />
        <div className="flex gap-4">
          {!isView && (
            <GroupButton
              type="btn-cancel"
              handleCloseUpdateDialog={() => handleIsView(true)}
            />
          )}
          {isView && timesheetInfo?.trangThai?.code !== CODE_STATUS.DA_DUYET 
            && hasAuthority(PERMISSIONS.BANG_CHAM_CONG, PERMISSION_ABILITY.APPROVE) && (
            <GroupButton handleEvent={() => setShouldOpenApproveDialog(true)}>{lang("BTN.APPROVE")}</GroupButton>
          )}
          {isView ? (hasAuthority(PERMISSIONS.BANG_CHAM_CONG, PERMISSION_ABILITY.UPDATE)
            && timesheetInfo?.trangThai?.code !== CODE_STATUS.DA_DUYET && (
              <>
                {timesheetInfo?.nam && timesheetInfo?.thang &&
                (
                  moment([timesheetInfo?.nam, Number(timesheetInfo?.thang) - 1, 1]).isSame(moment(), 'month') ||
                  (
                    moment([timesheetInfo?.nam, Number(timesheetInfo?.thang) - 1, 1]).isBefore(moment(), 'month') &&
                    moment().date() <= 10
                  )
                ) &&
                    <GroupButton handleEvent={updateAutoTimeSheets} className="spaces mr-4">{lang("BTN.UPDATE")}</GroupButton>
                  }
                <GroupButton type="btn-edit" handleSaveEdit={() => handleIsView(false)} />
              </>
            )
          ) : (
            <GroupButton type="btn-save" handleSubmit={handleSubmit} />
          )}
        </div>
      </div>
      <div className="form-content-scroll">
        <Row className="g-3 pt-3">
          <Col xs={12} sm={6} md={5} lg={4} xl={3} xxl={3}>
            <TextValidator
              readOnly
              lable={lang("GENERAL.CURRENT_ORGANIZATION")}
              value={timesheetInfo?.donViCongTacText || ""}
              name={VARIABLE_STRING.DON_VI_CONG_TAC}
            />
          </Col>
          <Col xs={12} sm={6} md={5} lg={4} xl={3} xxl={3}>
            <TextValidator
              readOnly
              lable={lang("INPUT.DEPARTMENTS")}
              value={timesheetInfo?.phongBanText || ""}
              name={VARIABLE_STRING.PHONG_BAN}
            />
          </Col>
          <Col xs={6} sm={3} md={2} lg={2} xl={1} xxl={1}>
            <TextValidator
              readOnly
              lable={lang("GENERAL.YEAR")}
              value={String(timesheetInfo?.nam) || ""}
              name={VARIABLE_STRING.YEAR}
              valueSearch="name"
            />
          </Col>
          <Col xs={6} sm={3} md={2} lg={2} xl={1} xxl={1}>
            <TextValidator
              readOnly
              lable={lang("GENERAL.MONTH")}
              value={timesheetInfo?.thang || ""}
              name={VARIABLE_STRING.MONTH}
              valueSearch="code"
            />
          </Col>
          <Col xs={6} sm={3} md={3} lg={2} xl={2} xxl={2}>
            <TextValidator
              readOnly
              lable={lang("GENERAL.STATUS")}
              value={timesheetInfo?.trangThai?.name || ""}
              name="trangThai"
            />
          </Col>
          <Col xs={6} sm={3} md={3} lg={2} xl={2}>
            <TextValidator
              readOnly
              name="ngayDuyet"
              lable={lang("DATE.APPROVE")}
              type="date"
              value={timesheetInfo?.ngayDuyet || ""}
            />
          </Col>
          <Col sm={6} md={4} lg={4} xl={3} xxl={3}>
            <TextValidator
              readOnly
              lable={lang("WELFARE.ACTUAL_COST.APPROVED_PEOPLE")}
              value={timesheetInfo?.nguoiDuyetText || ""}
              name="nguoiDuyet"
            />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className={!isShowSymbol ? "show-full" : ""}>
            <div className="relative pt-2 mb-3">
              <p className='fw-bold text-uppercase fs-1 text-center m-0'>bảng chấm công</p>
              <p className='fw-bold fs-4 text-center m-0'>{`Tháng ${timesheetInfo.thang ?? "....."} năm ${timesheetInfo.nam ?? "....."}`}</p>
              {isView && (
                <div className="position-absolute bottom-0 end-0 d-flex spaces gap-2">
                  <GroupButton handleEvent={() => setOpenDialogListAttribution(true)}>
                    {lang("TYPE_ATTRIBUTION")}
                  </GroupButton>
                  <GroupButton handleEvent={() => setOpenDialogPrint((prev: any) => {
                    return {
                      ...prev,
                      open: true
                    }
                  })}>
                    {lang("BTN.PRINT")}
                  </GroupButton>
                  <GroupButton outline handleEvent={() => handleExportTimekeeping()}>
                    <KTSVG path="/media/icons/export-excel.svg" />{" "}
                    {lang("BTN.EXPORT")}
                  </GroupButton>
                </div>
              )}
            </div>
            <TableTimesheets
              data={[...initDataTable]}
              dateSearch={timesheetInfo}
              dataKHChamCong={dataKHChamCong}
              isView={isView}
              refsArray={refsArray}
              setRefsArray={setRefsArray}
              listAttribution={listAttribution}
            />
          </Col>
        </Row>
        <Col xs={12} className='fw-bold pt-2'>
          Kí hiệu chấm công:
          <span className='action-symbol' onClick={() => setIsShowSymbol(!isShowSymbol)}>
            {lang(isShowSymbol ? "GENERAL.COLLAPSE" : "GENERAL.SHOW")}
          </span>
        </Col>
        {isShowSymbol && (
          <Row className='ps-6'>
            {dataKHChamCong.map((item: any) => {
              return <Col xs={3} className='spaces flex fs-12'>
                <p className='m-0'>{item?.name}</p>:
                <p className='m-0 fw-bold ps-1 color-crimson-red'>{item?.code}</p>
              </Col>
            })}
          </Row>
        )}
      </div>
      {shouldOpenApproveDialog &&
        <ConfirmDialog
          show={true}
          title={lang("DIALOG.CONFIRM")}
          message="Bạn có chắc chắn muốn duyệt bảng công?"
          cancel={lang("BTN.CLOSE")}
          onCancelClick={handleCloseForm}
          yes={lang("BTN.CONFIRM")}
          onYesClick={handleConfirm}
        />
      }
      {openDialogListAttribution &&
        <DialogListAttribution
          open={openDialogListAttribution}
          list={listAttribution}
          handleSave={(listAttribution: IAttribution[]) => handleSaveAttribution(listAttribution)}
          handleClose={() => setOpenDialogListAttribution(false)}
        />
      }
      {openDialogTypeExport.open &&
        <DialogTypeExportTimekeeping
          open={openDialogTypeExport.open}
          list={openDialogTypeExport.data}
          handleSave={(listCode: string[]) => handleExportExcel(listCode)}
          handleClose={() => setOpenDialogTypeExport({
            open: false,
            data: []
          })}
        />
      }
      {openDialogPrint.open && 
        <DialogPrintTimekeeping 
        open={openDialogPrint}
        dateSearch={openDialogPrint.dataSearchPrint || {...SEARCH_OBJECT_MAX_SIZE,...timesheetInfo}}
        listAttribution={listAttribution}
        handleClose={() => setOpenDialogPrint({
          open: false,
          dataSearchPrint: null
        })}
      />
      }
    </div>
  )
}

export default TimesheetForm;
